var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"area"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('SiruiSearch',{attrs:{"query":_vm.meterDetail,"columns":_vm.formColumn,"isQueryPanel":false}}),_c('el-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }